<template>
  <el-tooltip
    class="item"
    effect="dark"
    :disabled="disabled"
    :content="content"
    :placement="placement"
    test-id="toolTip"
  >
    <slot></slot>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },
    content: {
      type: String,
      default: () => ''
    },
    placement: {
      type: String,
      default: () => 'bottom'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.el-tooltip__popper.is-dark,
.el-tooltip__popper {
  background: rgb(36, 66, 148) !important;
}
</style>
